// import quotationSync from './quotationSync';
import quotationSync from './newIndex';
import machineSwitch from './machineSwitch';
import machine from './index';
import machineProject from './machineProject';

export default {
    path:'/home/machine',
    component:machine,
    children:[
        { path : '/home/quotation/sync', component : quotationSync},
        { path : '/home/machine/switch', component : machineSwitch},
        { path : '/home/machine/project', component : machineProject}
    ]
}

